export default function(state = {}, action) {
  const typeMap = {
    MIC_IX_PAGE_LOADING() {
      return {
        isLoading: true,
        micIxPage: action.micIxPage
      };
    },
    MIC_IX_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.micIxPage
      };
    },
    MIC_IX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micIxPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
